interface WithDisplayName {
  displayName: string | undefined;
}

const displayNameComparator = <T extends WithDisplayName>(a: T, b: T) =>
  (a.displayName ?? "").localeCompare(b.displayName ?? "");

export default displayNameComparator;
